import { ButtonBase, styled } from '@mui/material';

/** Text-only sibling of `Pill` for row actions: "+ Add", "+N more", "Show less". */
export const PillLinkChip = styled(ButtonBase)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  border: '1px solid transparent',
  borderRadius: 999,
  padding: '0.125rem 0.5rem',
  font: 'inherit',
  fontSize: '0.71875rem',
  fontWeight: 600,
  color: theme.palette.custom.OV.sys.secondary,
  backgroundColor: 'transparent',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
  },
}));
